type ContactWithEmails = {
  emails?: Array<string | { email?: string | null } | null> | null
  email?: string | null
}

export const primaryEmailFromContact = (contact: ContactWithEmails): string => {
  const first = contact?.emails?.[0]
  if (first == null) return contact?.email ?? ''
  return typeof first === 'string' ? first : first?.email ?? ''
}
